'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultMappings = {
  campaign: 'campaign_id',
  charity: 'charity_id',
  endDate: 'end_at',
  filter: 'q',
  group: 'group_value',
  pageIds: 'page_ids',
  startDate: 'start_at',
  type: 'group_by'
};

var defaultTransforms = {};

exports.default = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$mappings = options.mappings,
      customMappings = _options$mappings === undefined ? {} : _options$mappings,
      _options$transforms = options.transforms,
      customTransforms = _options$transforms === undefined ? {} : _options$transforms;


  var mappings = _extends({}, defaultMappings, customMappings);

  var transforms = _extends({}, defaultTransforms, customTransforms);

  var transformedParams = Object.keys(params).reduce(function (transformedParams, param) {
    var transform = transforms[param];
    var value = params[param];
    var transformedValue = transform ? transform(value) : value;
    return _extends({}, transformedParams, _defineProperty({}, param, transformedValue || value));
  }, {});

  var mappedParams = Object.keys(transformedParams).reduce(function (mappedParams, param) {
    var key = mappings[param] || param;
    return _extends({}, mappedParams, _defineProperty({}, key, transformedParams[param]));
  }, {});

  return mappedParams;
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/map/index.js
// module id = 1383
// module chunks = 0